
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';
import DatePicker from '@/components/DatePicker.vue';

@Component({ components: { DatePicker } })
export default class User extends Vue {
  public desserts = [];
  public roles = [];
  public companies = [];
  public dialog = false;
  public resetDialog = false;
  public roleDialog = false;
  public formTitle = 'مدیریت کاربران';
  public resetFormTitle = 'بازیابی رمز عبور';
  public roleFormTitle = 'دسترسی کاربر';
  public showPassword = false;
  public editedIndex = -1;
  public headers = [
    { text: 'نام کاربر', value: 'fullName', align: 'start' },
    { text: 'شرکت', value: 'company' },
    { text: 'سطح دسترسی', value: 'role' },
    { text: 'ایمیل', value: 'email' },
    { text: 'موبایل', value: 'phoneNumber' },
    { text: 'IP آخرین ورود', value: 'lastLoginIp' },
    { text: 'تاریخ آخرین ورود', value: 'lastLoginDate' },
    { text: 'وضعیت', value: 'isDisabled' },
    { text: 'عملیات', value: 'action', sortable: false }
  ];
  private editedItem = {
    id: 0,
    firstName: '',
    lastName: '',
    phoneNumber: '',
    companyId: 0,
    email: '',
    password: '',
    roleId: 0,
    allowedIp: ''
  };
  private defaultItem = {
    id: 0,
    firstName: '',
    lastName: '',
    phoneNumber: '',
    companyId: 0,
    email: '',
    password: '',
    roleId: 0,
    allowedIp: ''
  };
  public resetEditedItem = {
    id: 0,
    password: '',
    confirmPassword: ''
  };
  public defaulEditedItem = {
    id: 0,
    password: '',
    confirmPassword: ''
  };
  public roleEditedItem = {
    id: 0,
    roleGroupIds: []
  };
  public defaulRoleEditItem = {
    id: 0,
    roleGroupIds: []
  };

  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: `مدیریت کاربران`,
      disabled: true,
      href: ''
    }
  ];

  async created() {
    await this.initialize();
    await Api.getCompanyShortList().then((response: any) => {
      this.companies = response.data;
    });
  }

  async initialize() {
    this.$showLoading();
    await Api.getRoles().then((response) => {
      this.roles = response.data;
    });
    await Api.getUsers().then((response) => {
      this.desserts = response.data;
      this.$hideLoading();
    });
  }

  async editItem(id: number) {
    await Api.getUser(id).then((response) => {
      this.editedItem = Object.assign({}, response.data);
      this.editedItem.id = id;
      this.editedIndex = id;
      this.$nextTick(async () => {
        this.dialog = true;
        this.$hideLoading();
      });
    });
  }

  async save() {
    const isValid = await (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    if (this.editedIndex == -1) {
      await Api.createUser(this.editedItem).then((response) => {
        this.close();
        this.$hideLoading();
      });
    } else {
      await Api.editUser(this.editedItem).then((response) => {
        this.close();
        this.$hideLoading();
      });
    }
    this.close();
    this.$hideLoading();
  }

  async deleteItem(id: number) {
    const confirmed = await this.$showConfirm('هشدار', 'آیا مطمئن هستید که می خواهید این مورد را حذف کنید؟');
    if (confirmed) {
      this.$showLoading();
      await Api.deleteUser(id).then((response) => {
        this.close();
        this.$showNotification('success', 'کاربر با موفقیت حذف شد.');
        this.$hideLoading();
      });
    }
  }

  resetPassword(id: number) {
    this.resetEditedItem.id = id;
    this.resetDialog = true;
  }

  async close() {
    this.dialog = false;
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
    this.resetDialog = false;
    this.resetEditedItem = Object.assign({}, this.defaulEditedItem);
    this.roleDialog = false;
    this.roleEditedItem = Object.assign({}, this.defaulRoleEditItem);
    this.initialize();
  }

  async passwordSave() {
    const isValid = await (this.$refs.PasswordObserver as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.resetPassword(this.resetEditedItem).then((response) => {
      this.$showNotification('success', 'رمز عبور با موفقیت تغییر یافت.');
      this.$hideLoading();
    });
    this.close();
  }

  async disableUser(id: number) {
    const confirmed = await this.$showConfirm('هشدار', 'آیا مطمئن هستید که می خواهید کاربر را غیر فعال نمایید؟');
    if (confirmed) {
      this.$showLoading();
      await Api.disableUser(id).then((response) => {
        this.$showNotification('success', 'کاربر با موفقیت غیر فعال شد.');
        this.$hideLoading();
      });
      this.close();
    }
  }

  async enableUser(id: number) {
    const confirmed = await this.$showConfirm('هشدار', 'آیا مطمئن هستید که می خواهید کاربر را فعال نمایید؟');

    if (confirmed) {
      this.$showLoading();
      await Api.enableUser(id).then((response) => {
        this.$showNotification('success', 'کاربر با موفقیت فعال شد.');
        this.$hideLoading();
      });
      this.close();
    }
  }

  // async getUserRole(id: number) {
  //   await Api.getRoleGroups().then((response) => {
  //     this.roles = response.data;
  //   });
  //   await Api.getUserRoleGroup(id).then((response) => {
  //     this.roleEditedItem = Object.assign({}, response.data);
  //     this.roleDialog = true;
  //   });
  // }

  // async createRole(id: number) {
  //   this.$showLoading();
  //   await Api.createUserRoleGroup(this.roleEditedItem).then((response) => {
  //     this.$showNotification('success', 'دسترسی کاربر بروز رسانی شد.');
  //     this.$hideLoading();
  //   });
  //   this.close();
  // }

  getColor(isDisabled: string) {
    if (isDisabled === 'فعال') {
      return 'green lighten-2';
    } else {
      return 'red lighten-1';
    }
  }
}
